import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import ImageWithBasePath from './ImageWithBasePath'

export function CarouselComponent({
  numberOfCarousels,
  time,
  children,
  dotsClassName = '',
  isArrowControl = false,
  arrowClassName = '',
  widthOfCard,
  containerClassname = '',
  minlenForArrowControlEnable = 3,
  fullWidth = true
}) {
  const [viewIndex, setViewIndex] = useState(0)
  const [dots, setDots] = useState([])
  const interval = useRef('')
  const timeOut = useRef('')

  const handler = () => {
    setViewIndex((prv) => (prv == numberOfCarousels - 1 ? 0 : prv + 1))
  }

  const arrowHandler = (arrow) => {
    if (minlenForArrowControlEnable < numberOfCarousels) {
      if (arrow == 'right')
        setViewIndex((prv) =>
          prv == numberOfCarousels - minlenForArrowControlEnable ? 0 : prv + 1
        )
      else
        setViewIndex((prv) =>
          prv == 0 ? numberOfCarousels - minlenForArrowControlEnable : prv - 1
        )
    }
  }

  const setIntervalToComp = () => {
    clearInterval(interval.current)
    interval.current = setInterval(() => handler(), time)
  }

  const clear = () => {
    clearInterval(interval.current)
    clearTimeout(timeOut.current)
  }

  useEffect(() => {
    if (!isArrowControl) setIntervalToComp()
    const temp = []
    for (let index = 0; index < numberOfCarousels; index++) temp.push(index)
    setDots([...temp])
    return () => clearInterval(interval.current)
  }, [numberOfCarousels])

  return (
    <div className={classNames('overflow-hidden', containerClassname)}>
      <div
        className=""
        onMouseOver={() => {
          clear()
        }}
        onMouseOut={() => {
          if (!isArrowControl) setIntervalToComp()
        }}
      >
        <div
          className={classNames(
            ` flex overflow-hidden text-center transition-all duration-1000 ease-in-out`
          )}
          style={{
            width: !fullWidth ? widthOfCard * numberOfCarousels - 1 : numberOfCarousels * 100 + '%',
            transform: `translateX(-${
              isArrowControl
                ? viewIndex * widthOfCard + 'px'
                : (viewIndex * 100) / numberOfCarousels + '%'
            })`
          }}
        >
          {children}
        </div>
        {!isArrowControl && (
          <div
            className={classNames('flex items-center justify-center space-x-[4px]', dotsClassName)}
          >
            {dots.map((item, index) => {
              return (
                <div
                  key={index}
                  className={classNames(
                    'h-[8px] w-[8px] rounded-full bg-[#E0E1E1]',
                    index === viewIndex && 'bg-[#FFBB00]'
                  )}
                />
              )
            })}
          </div>
        )}
        {isArrowControl && (
          <div
            className={classNames(
              ' flex items-center justify-center space-x-[12px] pt-16',
              arrowClassName
            )}
          >
            <div
              className="relative h-[48px] w-[48px] cursor-pointer"
              onClick={() => arrowHandler('left')}
            >
              <ImageWithBasePath src="big_arrow_left_button" fill alt={'left control symbol'} />
            </div>
            <div
              className="relative h-[48px] w-[48px] cursor-pointer"
              onClick={() => arrowHandler('right')}
            >
              <ImageWithBasePath src="big_arrow_right_button" fill alt={'right control symbol'} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
